module.exports = __webpack_public_path__ + "img/vessel_visitation_8_63021.9b46102d.jpg";